<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        รายงานตารางอัตราค่าบริการเฉลี่ยของการกำกับดูแลและอัตราค่าบริการเฉลี่ยบริการโทรศัพท์เคลื่อนที่ของแต่ละผู้ให้บริการ 
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <!-- <i class="fa fa-dashboard"></i> รายงานตารางอัตราค่าบริการเฉลี่ยของการกำกับดูแลและอัตราค่าบริการเฉลี่ยบริการโทรศัพท์เคลื่อนที่ของแต่ละผู้ให้บริการ -->
          </a>
        </li>
      </ol>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-sm-12">
            <div class="box box-primary">
              <div class="box-header">
                <!-- <h3 class="box-title">Hover Data Table</h3> -->
                <div class="layout_filter_search">
                  <h2>ตัวเลือกการค้นหา</h2>
                  <div class="row">
                    <el-form
                      size="mini"
                      :label-position="label_position"
                      label-width="150px"
                      :model="form"
                      ref="ruleForm"
                      class="demo-ruleForm"
                    >
                      <div class="col-md-12">
                        <div class="row">
                          <div class="col-md-6">
                              <div class="col-sm-12">
                                <el-form-item label="ประเภทรายงาน" required>
                                  <el-select
                                    ref="type_report"
                                    v-model="form.type_report"
                                    @change="clear_data"
                                  >
                                    <el-option label="รายเดือน" value="month"></el-option>
                                    <el-option label="ระหว่างเดือน" value="between_month"></el-option>
                                    <el-option label="รายปี" value="year"></el-option>
                                    <el-option label="ระหว่างปี" value="between_year"></el-option>
                                    <el-option label="ไตรมาส" value="quarter"></el-option>
                                    <el-option label="ช่วงไตรมาส" value="quarterss"></el-option>
                                  </el-select>
                                </el-form-item>
                              </div>
                          </div>
                          <div class="col-md-6">
                              <div class="col-sm-12">
                                <el-form-item
                                  label="กรุณาเลือกประเภทรายงาน"
                                  v-if="form.type_report === ''"
                                >
                                  <el-input disabled placeholder></el-input>
                                </el-form-item>
                                <el-form-item
                                  label="ช่วงเวลา"
                                  v-bind:class="[form.type_report === 'month' ?  '': 'not_display']"
                                  required
                                >
                                  <el-date-picker
                                    ref="month"
                                    v-model="form.type_data.month"
                                    
                                    :default-value="defaultDate"
                                    type="month"
                                    clearable
                                  ></el-date-picker>
                                </el-form-item>
                                <el-form-item
                                  label="ช่วงเวลา"
                                  v-bind:class="[form.type_report === 'between_month' ?  '': 'not_display']"
                                  required
                                >
                                  <el-date-picker
                                    ref="monthfrom"
                                    :default-value="defaultDate"
                                    v-model="form.type_data.monthfrom"
                                    style="width:45%;"
                                    type="month"
                                    clearable
                                  ></el-date-picker>&nbsp;&nbsp;-&nbsp;
                                  <el-date-picker
                                    ref="monthto"
                                    :default-value="defaultDate"
                                    v-model="form.type_data.monthto"
                                    style="width:45%;"
                                    type="month"
                                    clearable
                                  ></el-date-picker>
                                </el-form-item>
                                <el-form-item
                                  label="ช่วงเวลา"
                                  v-bind:class="[form.type_report === 'year' ?  '': 'not_display']"
                                  required
                                >
                                  <el-date-picker
                                    ref="year"
                                    v-model="form.type_data.year"
                                    
                                    type="year"
                                    :default-value="defaultDate"
                                    clearable
                                  ></el-date-picker>
                                </el-form-item>
                                <el-form-item
                                  label="ช่วงเวลา"
                                  v-bind:class="[form.type_report === 'between_year' ?  '': 'not_display']"
                                  required
                                >
                                  <el-date-picker
                                    ref="yearfrom"
                                    v-model="form.type_data.yearfrom"
                                    type="year"
                                    style="width: 45%"
                                  ></el-date-picker>&nbsp;&nbsp;-&nbsp;
                                  <el-date-picker
                                    ref="yearto"
                                    v-model="form.type_data.yearto"
                                    type="year"
                                    style="width: 45%"
                                  ></el-date-picker>
                                </el-form-item>
                                <el-form-item
                                  label="ช่วงเวลา"
                                  v-bind:class="[form.type_report === 'quarter' ?  '': 'not_display']"
                                  required
                                >
                                  <el-select
                                    style="width:50%;"
                                    ref="quarter"
                                    v-model="form.type_data.quarter"
                                  >
                                    <el-option label="1" value="1"></el-option>
                                    <el-option label="2" value="2"></el-option>
                                    <el-option label="3" value="3"></el-option>
                                    <el-option label="4" value="4"></el-option>
                                  </el-select>&nbsp;
                                  <el-date-picker
                                    v-model="form.type_data.quarter_year"
                                    ref="quarter_year"
                                    type="year"
                                  ></el-date-picker>
                                </el-form-item>
                                <el-form-item
                                  label="ช่วงเวลา"
                                  v-if="form.type_report === 'quarterss'"
                                  v-bind:class="[form.type_report === 'quarterss' ?  '': 'not_display']"
                                  required
                                >
                                  <el-select
                                    style="width:20%;"
                                    ref="quarterfrom"
                                    v-model="form.type_data.quarterfrom"
                                  >
                                    <el-option label="1" value="1"></el-option>
                                    <el-option label="2" value="2"></el-option>
                                    <el-option label="3" value="3"></el-option>
                                    <el-option label="4" value="4"></el-option>
                                  </el-select>&nbsp;
                                  <el-date-picker
                                    style="width:25%;"
                                    v-model="form.type_data.quarter_year_from"
                                    ref="quarter_year"
                                    type="year"
                                  ></el-date-picker>&nbsp;&nbsp;-&nbsp;
                                  <el-select
                                    style="width:20%;"
                                    ref="quarterto"
                                    v-model="form.type_data.quarterto"
                                  >
                                    <el-option label="1" value="1"></el-option>
                                    <el-option label="2" value="2"></el-option>
                                    <el-option label="3" value="3"></el-option>
                                    <el-option label="4" value="4"></el-option>
                                  </el-select>&nbsp;
                                  <el-date-picker
                                    v-model="form.type_data.quarter_year"
                                    ref="quarter_year"
                                    type="year"
                                    style="width:25%;"
                                  ></el-date-picker>
                                </el-form-item>
                              </div> 
                          </div>
                          <div class="col-sm-6">
                            <div class="col-sm-12">
                              <el-form-item label="ประเภทผู้ให้บริการ">
                                <el-radio-group v-model="form.compare_type" @change="compareType">
                                  <el-radio label="group">กลุ่มผู้ให้บริการ</el-radio>
                                  <el-radio label="provider">รายชื่อผู้ให้บริการ</el-radio>
                                </el-radio-group>
                              </el-form-item>
                            </div>
                            <div class="col-sm-12">
                              <el-form-item label="กลุ่มผู้ให้บริการ" :required="cType">
                                <el-checkbox-group v-model="form.provider_group" :disabled="!cType">
                                  <el-checkbox 
                                  ref="provider_group"
                                    v-for="group in this.store_groups" 
                                    :key="group.id" 
                                    :label="group.id">
                                    {{group.group_name_th}}
                                  </el-checkbox>
                                </el-checkbox-group>
                              </el-form-item>
                            </div>
                            <div class="col-sm-12">
                              <el-form-item label="รายชื่อผู้ให้บริการ" :required="!cType">
                                <el-checkbox-group v-model="form.provider_list" :disabled="cType">
                                  <el-checkbox 
                                  ref="provider_list"
                                    v-for="provider in this.store_providers" 
                                    :key="provider.id" 
                                    :label="provider.id">
                                    {{provider.brand_name}}
                                  </el-checkbox>
                                </el-checkbox-group>
                              </el-form-item>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="col-sm-12">
                              <el-form-item label="ย่านความถี่">
                                <el-radio-group v-model="form.frequency">
                                  <el-radio :label="900">900 MHz</el-radio>
                                  <el-radio :label="1800">1800 MHz</el-radio>
                                  <el-radio :label="2100">2.1 GHz</el-radio>
                                  <el-radio label="other">อื่นๆ</el-radio>
                                </el-radio-group>
                              </el-form-item>
                            </div>
                            <div class="col-sm-12">
                              <el-form-item label="แสดงค่าบริการเฉลี่ยแบบถ่วงน้ำหนัก">
                                <el-radio-group v-model="form.weighting">
                                  <el-radio :label="1">แสดง</el-radio>
                                  <el-radio :label="0">ไม่แสดง</el-radio>
                                </el-radio-group>
                              </el-form-item>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <el-form-item label="สถานะการให้บริการ">
                              <el-checkbox-group v-model="form.service_status">
                                  <el-checkbox label="S">ประเภทบุคคลทั่วไป (รายการส่งเสริมการขายที่ยังขายอยู่)</el-checkbox><br/>
                                  <el-checkbox label="U">ประเภทบุคคลทั่วไป (รายการส่งเสริมการขายที่ไม่ขายแล้ว แต่ยังให้บริการอยู่)</el-checkbox><br/>
                                  <el-checkbox label="CS">ประเภทองค์กร (รายการส่งเสริมการขายที่ยังขายอยู่)</el-checkbox><br/>
                                  <el-checkbox label="CU">ประเภทองค์กร (รายการส่งเสริมการขายที่ไม่ขายแล้ว แต่ยังให้บริการอยู่)</el-checkbox><br/>
                              </el-checkbox-group>
                            </el-form-item>
                          </div>
                          <div class="col-sm-6">
                            <el-form-item label="แสดงอัตราที่กำกับดูแล" required>
                              <el-radio-group v-model="form.regulate">
                                <el-radio v-for="item in regulate_list" :key="item.id" :label="item.id">{{item.service_name}}</el-radio>
                              </el-radio-group>
                            </el-form-item>
                          </div>
                        </div>
                      </div>
                      <div class="layout_filter_btn">
                        <button type="button" class="btn btn-primary" @click="find_report()">ค้นหา</button>
                      </div>
                    </el-form>
                  </div>
                  <div class="box-body">
                    <div class="col-sm-12">
                      <div class="row" v-if="show_table" v-loading="loading">
                        <div class="col-sm-12" style="width:100%;text-align:right;padding-bottom:20px">
                            <div class="col-sm-12" style="text-align:right;">
                              <el-dropdown @command="exportFile" v-loading="pending">
                                <span class="btn btn-primary" >
                                  Export<i class="el-icon-arrow-down el-icon--right"></i>
                                </span>
                                <el-dropdown-menu slot="dropdown" style="padding-right:2%">
                                  <el-dropdown-item icon="el-icon-download" command="pdf">Export PDF</el-dropdown-item>
                                  <el-dropdown-item icon="el-icon-download" command="doc">Export DOC</el-dropdown-item>
                                  <el-dropdown-item icon="el-icon-download" command="xls">Export XLS</el-dropdown-item>
                                </el-dropdown-menu>
                              </el-dropdown>
                            </div>
                        </div>
                        <div class="col-sm-1"></div>
                        <div class="col-sm-10" id="rawdata" style="display: none">
                          <div class="col-sm-12" style="text-align: center;margin-bottom: 5px;">
                            <label for="text title" ><h4>{{text_title}}</h4></label>
                          </div>
                          <table class="table table-hover table-responsive">
                            <tr bgcolor="#99ccff">
                              <th style="width:250px"></th>
                              <th> เสียง <br />(บาท/นาที) </th>
                              <th> SMS <br />(บาท/ข้อความ) </th>
                              <th> MMS <br />(บาท/ข้อความ) </th>
                              <th> Internet <br />(บาท/MB) </th>
                            </tr>
                            <tr bgcolor="#e6f2ff">
                              <td>{{regulate.service_name}}</td>
                              <td>{{regulate.Voice}}</td>
                              <td>{{regulate.SMS}}</td>
                              <td>{{regulate.MMS}}</td>
                              <td>{{regulate.Internet}}</td>
                            </tr>
                            <tr bgcolor="#e6f2ff" v-if="reducer">
                              <td>{{reducer.service_name}}</td>
                              <td>{{reducer.Voice}}</td>
                              <td>{{reducer.SMS}}</td>
                              <td>{{reducer.MMS}}</td>
                              <td>{{reducer.Internet}}</td>
                            </tr>
                            <tbody v-for="(item,month) in table_data" :key="month">
                             <tr><td bgcolor="#99ccff" colspan="5">{{month}}</td></tr>
                             <tr bgcolor="#e6f2ff" v-for="(service,provider) in item" :key="provider">
                               <td>{{provider}}</td>
                               <td v-for="(value,service) in service" :key="service" :class="[(value > (reducer ? reducer[service] : regulate[service])) ? 'color-red' : 'color-green']">{{value > 0 ? value : '-'}}</td>
                             </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="col-sm-10" id="data" ref="tableData">
                          <div class="col-sm-12" style="text-align: center;margin-bottom: 5px;">
                            <label for="text title" ><h4>{{text_title}}</h4></label>
                          </div>
                          <table class="table table-hover table-responsive">
                            <tr bgcolor="#99ccff">
                              <th style="width:250px"></th>
                              <th> เสียง <br />(บาท/นาที) </th>
                              <th> SMS <br />(บาท/ข้อความ) </th>
                              <th> MMS <br />(บาท/ข้อความ) </th>
                              <th> Internet <br />(บาท/MB) </th>
                            </tr>
                            <tr bgcolor="#e6f2ff">
                              <td>{{regulate.service_name}}</td>
                              <td>{{regulate.Voice}}</td>
                              <td>{{regulate.SMS}}</td>
                              <td>{{regulate.MMS}}</td>
                              <td>{{regulate.Internet}}</td>
                            </tr>
                            <tr bgcolor="#e6f2ff" v-if="reducer">
                              <td>{{reducer.service_name}}</td>
                              <td>{{reducer.Voice}}</td>
                              <td>{{reducer.SMS}}</td>
                              <td>{{reducer.MMS}}</td>
                              <td>{{reducer.Internet}}</td>
                            </tr>
                            <tbody v-for="(item,month) in table_data" :key="month">
                             <tr><td bgcolor="#99ccff" colspan="5">{{month}}</td></tr>
                             <tr bgcolor="#e6f2ff" v-for="(service,provider) in item" :key="provider">
                               <td  >{{provider}}</td>
                               <td v-for="(value,service) in service" :key="service" :class="[(value > (reducer ? reducer[service] : regulate[service])) ? 'color-red' : 'color-green']">{{value > 0 ? value.toFixed(2) : '-'}}</td>
                             </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="col-sm-1"></div>
                      </div>
                      <h4 v-if="data_not_found" align="center">ไม่พบข้อมูลที่ต้องการค้นหา</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import moment from "moment";
import utility from "../../lib/utility";
import jsPDF from "jspdf";
export default {
  data() {
    return {
      defaultDate: "",
      show: false,
      label_position: "top",
      form: {
        type_data: {
          quarter: "",
          year: "",
          month: "",
          monthfrom: "",
          monthto: "",
          quarter_year_from:"",
          quarter_year: "",
          quarterfrom: [],
          quarterto: [],
          yearfrom: "",
          yearto: ""
        },
        provider_group : [],
        provider_list : [],
        service_type: "",
        service_providers: [],
        frequency: 2100,
        weighting: 0,
        service_status: ['S','U','CS','CU'],
        checkList: [],
        type_report: "",
        year: "",
        quarter: "",
        compare_type : "group",
        list : {},
        regulate : null
      },
      cType : true,
      pending: false
    }
  },
  beforeCreate() {
    this.$store.dispatch('Report_pmt/getGroupCompany','mobile')
    this.$store.dispatch('Report_pmt/getProviderByType','mobile')
    this.$store.dispatch('Report_pt/getRegulateRate')
  },
  computed: {
    ...mapState({
      text_title:store => store.Report_pt.text_title,
      store_groups : store => store.Report_pmt.provider_group,
      store_providers : store => store.Report_pmt.provider_list,
      table_data : store => store.Report_pt.data_table,
      show_table : store => store.Report_pt.show_table,
      loading : store => store.Report_pt.loading,
      regulate : store => store.Report_pt.regulator,
      data_not_found : store => store.Report_pt.data_not_found,
      regulate_list : store => store.Report_pt.regulate_list,
      reducer : store => store.Report_pt.reducer
    })
  },
  methods: {
    ...mapActions({
      reportMonth: "Report_pt/reportMonth",
      reportQuarter: "Report_pt/reportQuarter",
      reportYear: "Report_pt/reportYear"
    }),
    clear_data() {
      this.form.type_data = {
        monthfrom: "",
        monthto: "",
        quarter: "",
        quarter_year: "",
        year: "",
        month: "",
        quarterfrom: [],
        quarterto: [],
        yearfrom: "",
        yearto: ""
      };
    },
    compareType(e){
      this.cType = e == 'group' ? true : false
      if(this.cType){
        this.form.provider_list = []
      }else{
        this.form.provider_group = []
      }
    },
    find_report() {
      if (this.form.type_report === "") {
        this.$alert("กรุณาเลือกประเภทรายงาน", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          type : 'warning',
          callback: action => {
            this.$refs.type_report.focus();
          }
        });
      } else if ( this.form.type_report === "month" && this.form.type_data.month === "") {
        this.$alert("กรุณาเลือกเดือน", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          type : 'warning',
          callback: action => {
            this.$refs.month.focus();
          }
        });
      } else if ( this.form.type_report === "between_month" && (this.form.type_data.monthfrom === "" || this.form.type_data.monthto === "")) {
        this.$alert("กรุณาเลือกระหว่างเดือน", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          type : 'warning',
          callback: action => {
            if (this.form.type_data.monthfrom.length == 0) {
              this.$refs.monthfrom.focus();
            } else {
              this.$refs.monthto.focus();
            }
          }
        });
      } else if ( this.form.type_report === "year" && this.form.type_data.year === "" ) {
        this.$alert("กรุณาเลือกปี", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          type : 'warning',
          callback: action => {
            this.$refs.year.focus();
          }
        });
      } else if ( this.form.type_report === "between_year" && (this.form.type_data.yearfrom.length === 0 || this.form.type_data.yearto.length === 0)) {
        this.$alert("กรุณาเลือกระหว่างปี", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          type : 'warning',
          callback: action => {
            if (this.form.type_data.yearfrom.length == 0) {
              this.$refs.yearfrom.focus();
            } else {
              this.$refs.yearto.focus();
            }
          }
        });
       }else if ( this.form.type_report === "quarter" && ( this.form.type_data.quarter === "" || this.form.type_data.quarter_year.length === 0)){
        this.$alert("กรุณาเลือกไตรมาส", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          type : 'warning',
          callback: action => {
            this.$refs.quarter.focus();
            if (this.form.type_data.quarter.length == 0) {
              this.$refs.quarter.focus();
            } else {
              this.$refs.quarter_year.focus();
            }
          }
        });
      } else if ( this.form.type_report === "quarterss" && (this.form.type_data.quarterfrom.length === 0 || this.form.type_data.quarterto.length === 0 || this.form.type_data.quarter_year === "")) {
        this.$alert("กรุณาเลือกช่วงไตรมาส", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          type : 'warning',
          callback: action => {
            if (this.form.type_data.quarterfrom.length === 0) {
              this.$refs.quarterfrom.focus();
            } else if (this.form.type_data.quarterto.length === 0) {
              this.$refs.quarterto.focus();
            } else {
              this.$refs.quarter_year.focus();
            }
          }
        });
      } else if ( (this.cType == true) && (this.form.provider_group.length === 0) ) {
        this.$alert("กรุณาเลือกกลุ่มผู้ให้บริการ", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          type : 'warning'
        });
      } else if ( (this.cType == false) && (this.form.provider_list.length === 0) ) {
        this.$alert("กรุณาเลือกรายชื่อผู้ให้บริการ", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          type : 'warning'
        });
      }else if(!this.form.regulate){
        this.$alert("กรุณาเลือกอัตรากำกับสำหรับเปรียบเทียบ", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          type : 'warning'
        });
      } else {
        this.$store.commit('Report_pt/DATA_NOT_FOUND',false)
        this.form.list = this.form.compare_type == 'group' 
          ? this.store_groups.filter(item => this.form.provider_group.includes(item.id)) 
          : this.store_providers.filter(item => this.form.provider_list.includes(item.id))
        switch(this.form.type_report){
          case 'month':
          case 'between_month':
            this.reportMonth(this.form)
            break
          case 'quarter':
          case 'quarterss':
            this.reportQuarter(this.form)
            break
          case 'year':
          case 'between_year':
            this.reportYear(this.form)
            break
        }
      }
    },
    generatePDF() {
      var doc = new jsPDF('landscape');
      doc.internal.scaleFactor = 1.8;
      this.$html2canvas(this.$refs.tableData, { canvas: null })
      .then(function(canvas) {
        const img = canvas.toDataURL("image/png",1.0);
        doc.addImage(img, "JPEG", 10, 10, 280, 150);
        doc.save("Report.pdf");
      });
    },
    exportFile(com){
      this.pending = true
      if(com=="pdf"){
        var doc = new jsPDF("portrait");
        doc.internal.scaleFactor = 10;
        this.$html2canvas(this.$refs.tableData, { canvas: null})
        .then(function(canvas){
          var ratio = canvas.width > canvas.height ? 210/canvas.width : 300/canvas.height
          var width = canvas.width*ratio > 210 ? 210 : canvas.width*ratio
          var height = canvas.height*ratio > 300 ? 300 : canvas.height*ratio
          var margin_left = (210-width)/2
          var margin_top = height > 300 ? 300 : (300-height)/2
          doc.addImage(canvas.toDataURL("image/png", 1.0), "JPEG", margin_left, 0, width, height);
          doc.save("Program_technologies.pdf");
        })
        .then(()=>{
          this.pending = false
        })
      }else if(com=="doc"){
        var header = "<html xmlns:o='urn:schemas-microsoft-com:office:office' "+
                      "xmlns:w='urn:schemas-microsoft-com:office:word' "+
                      "xmlns='http://www.w3.org/TR/REC-html40'>"+
                      "<head><meta charset='utf-8'><title>Export HTML to Word Document with JavaScript</title></head><body>";
        var footer = "</body></html>";
        var sourceHTML = header+document.getElementById("data").innerHTML+footer;
        var source = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(sourceHTML);
        var fileDownload = document.createElement("a");
        document.body.appendChild(fileDownload);
        fileDownload.href = source;
        fileDownload.download = 'Program_technologies.doc';
        fileDownload.click()
        document.body.removeChild(fileDownload)
        this.pending = false
      }else if(com=="xls"){
        var header = "<html xmlns:o='urn:schemas-microsoft-com:office:office' "+
                      "xmlns:w='urn:schemas-microsoft-com:office:word' "+
                      "xmlns='http://www.w3.org/TR/REC-html40'>"+
                      "<head><meta charset='utf-8'><title>Export HTML to Word Document with JavaScript</title></head><body>";
        var footer = "</body></html>";
        var sourceHTML = header+document.getElementById("rawdata").innerHTML+footer;
        var source = 'data:application/vnd.ms-excel;charset=utf-8,' + encodeURIComponent(sourceHTML);
        var fileDownload = document.createElement("a");
        document.body.appendChild(fileDownload);
        fileDownload.href = source;
        fileDownload.download = 'Program_technologies.xls';
        fileDownload.click();
        document.body.removeChild(fileDownload)
        this.pending = false
      }
    },
  }
};
</script>
<style scoped>
    table,td,th {
      /* border: 1px solid black; */
    }
    table {
      /* border-collapse: collapse; */
      width: 100%;
    }
    table tr th {
      text-align: center;
      height: 55px;
    }
    th,
    tr {
      height: 30px;
      text-align: center;
      width: 150px !important;
    }
    .color-red {
      color: red !important;
    }
    .color-green {
      color: green !important;
    }
</style>
